
import { Vue, Options } from 'vue-class-component'
import { dashboardDataFactory } from '@/http/dashboard-data'
import constants from '@/constants/constants'

@Options({
  props: {
    param: Object
  },
  name: 'DetailPayment',
  watch: {
    param: {
      handler: 'resetloadDatas',
      deep: true
    }
  },
  data () {
    return {
      invoices: [],
      offset: 0,
      months: constants.MONTHS,
      searchKey: '',
      timer: null,
      enableScroll: true
    }
  },
  methods: {
    loadDatas: async function () {
      Promise.all([
        dashboardDataFactory.detailPayment(this.param, 10, this.offset, this.searchKey)
      ])
        .then((response) => {
          const data = response[0].data

          if (data.length == 0 && this.offset > 0) {
            this.enableScroll = false
            // make footer to show no more data
            document.getElementById('footer-detail-payment').style.display = 'block'
            setTimeout(() => {
              document.getElementById('footer-detail-payment').style.display = 'none'
            }, 3000)
          }

          // looping data
          const lastNumber = this.invoices.length
          for (let i = 0; i < data.length; i++) {
            const id = data[i].id
            const month = id.split('-')[2]
            let kelas = ''
            if (data[i].user.active_user_class) {
              if (data[i].user.active_user_class.class) {
                if (data[i].user.active_user_class.class.name) {
                  kelas = data[i].user.active_user_class.class.name
                }
              }
            }
            const temp = {
              no: lastNumber + i + 1,
              kelas: kelas,
              nama: data[i].user.name || '',
              tagihan: (data[i].bill.name || '') + ' bulan ' + this.months[month],
              nominal: data[i].total_amount,
              status:
                data[i].status == constants.BILL_PAID ||
                  data[i].status == constants.BILL_OVERPAID
                  ? 'Lunas'
                  : 'Belum Lunas',
              dibayarkan: data[i].paid_date || '',
              user_status: data[i].user.status || ''
            }
            this.invoices.push(temp)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    scroll: function (e) {
      if (
        e.target.scrollTop + e.target.clientHeight + 1 >=
        e.target.scrollHeight && this.enableScroll
      ) {
        this.offset += 10
        this.loadDatas()
      }
    },
    resetloadDatas: function () {
      this.invoices = []
      this.offset = 0
      this.enableScroll = true
      this.loadDatas()
    },
    search: function (e) {
      // debounce
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.searchKey = e.target.value
        this.invoices = []
        this.offset = 0
        this.enableScroll = true
        this.loadDatas()
      }, 500)
    }
  },
  mounted () {
    this.loadDatas()
  }
})
export default class DetailPayment extends Vue { }
